import React, { useState,useEffect,useRef } from "react";
import { MultiSelect } from "react-multi-select-component";
const options = [
  { label: "Grapes", value: "grapes" },
  { label: "Mango", value: "mango" },
  { label: "Strawberry", value: "strawberry", disabled: true },
];
const overrideStrings={
  "allItemsAreSelected": "Все элементы выбраны.",
  "clearSearch": "Очистить поиск",
  "clearSelected": "Очистить выбранное",
  "noOptions": "Нет данных",
  "search": "Поиск",
  "selectAll": "Выбрать все",
  "selectAllFiltered": "Выбрать все (отфильтровано)",
  "selectSomeItems": " ",
  "create": "Создать",
}
const filterOptions = (options, filter) => {
  if (!filter) {
    return options;
  }
  const re = new RegExp(filter, "i");
  return options.filter(({ label }) => label && label.match(re));
  //return options.filter(({ value }) => value && value.length > 1);
};

const MultipleSelect = ({selectList,curValue,onHandleChange}) => {
  const [selected, setSelected] = useState([]);
  const mult = useRef();
  useEffect(() => {
    if (curValue)
     setSelected(curValue)
  }, [curValue]);

  useEffect(() => {
    onHandleChange(selected)
  }, [selected]);

  const customStyles = {
    control: base => ({
      ...base,
      height: 35,
      minHeight: 35
    })
  };
  
  return (
    <div>
      {/*<pre>{JSON.stringify(selected)}</pre>*/}
      <MultiSelect
        options={selectList}
        value={selected}
        onChange={setSelected}
        labelledBy={null}
        hasSelectAll={false}
        filterOptions={filterOptions}
        overrideStrings={overrideStrings}
      />
    </div>
  );
};

export default MultipleSelect;